module.exports = __webpack_public_path__ + "static/blog2-7c93e058596b610c4614e5d2990aaf0d.png";